<template>
    <div>
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="汇入银行">
                <el-select v-model="jsonData.bankname" placeholder="请选择" class="el-select-medium">
                    <el-option v-for="(item, index) in banknameList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="凭证类型">
                <el-select v-model="jsonData.receipttype" placeholder="请选择" class="el-select-medium">
                    <el-option v-for="(item, index) in receiptTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="汇款单位">
                <el-input v-model="jsonData.receiptcode" placeholder="请输入" clearable class="el-select-medium"></el-input>
            </el-form-item>
            <el-form-item label="汇款金额">
                <el-input v-model="jsonData.receiptcount" placeholder="请输入" clearable class="el-select-medium"></el-input>
            </el-form-item>
            <el-form-item label="付款日期">
                <el-date-picker v-model="jsonData.ReceiptPayDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getSPCOrders(true)" icon="el-icon-search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button @click="resetData" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" @click="openReceipt(1)">新增</el-button>
            </el-form-item>
        </el-form>
        <div class="content-table">
            <el-table :data="PaymentReceiptList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                <el-table-column width="55" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.Receipt_ID_Show" :label="1" @input="handleSelectionChange(scope.row)">{{ '' }}</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_ID" label="ID" align="center" width="70"></el-table-column>
                <el-table-column prop="Receipt_BankName" label="汇入银行" align="center"></el-table-column>
                <el-table-column prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                <el-table-column prop="Receipt_Code" label="汇款单位" align="center" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Receipt_PayDate" label="付款日期" align="center"></el-table-column>
                <el-table-column prop="Receipt_Amount" label="汇款金额" align="center">
                    <template slot-scope="scope">
                        ￥
                        <span>{{ scope.row.Receipt_Amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Last_Amount" label="剩余金额" align="center">
                    <template slot-scope="scope">
                        ￥
                        <span>{{ scope.row.Last_Amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_Addtime" label="录入时间" align="center" width="140"></el-table-column>
                <el-table-column label="凭证附件" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="viewPaymentReceiptFile(scope.row.Payment_Receipt_File)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="本次分配金额" align="center" width="130">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.inputValue" placeholder="请输入" clearable class="" @input="formatOnInput(scope.row)" @blur="valueBlur(scope.row)"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <div class="button-container">
            <el-button type="primary" @click="submit">保存</el-button>
        </div>
    <PaymentVoucher ref="PaymentVoucherDialog" @success="resetData" :append-to-body="true" />

    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import PaymentVoucher from '@/components/PaymentVoucher/index.vue';
export default {
    components: {
        Pagination,
        PaymentVoucher
    },
    props: {
        cateid: {
            type: String,
            default: ''
        },
        residuePrice: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            jsonData: {
                bankname: '', //银行名称
                receipttype: '', //凭证类型
                receiptcode: '', //汇款单位
                receiptcount: '', //汇款金额
                ReceiptPayDate: '' //付款日期
            },
            page: 1,
            pageEnd: 0,
            PaymentReceiptList: [],
            jsonShowData: {},
            banknameList: [],
            receiptTypeList: [],
            selectedRows: [],
            // 添加分页配置
            paginationOptions: {
                Page: 1,
                total: 0,
                PageSize: 10
            }
        };
    },
    mounted() {
        this.resetData();
        this.GetBankname();
        this.GetReceiptType();
    },
    methods: {
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.selectOrdersPaymentReceipt();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.selectOrdersPaymentReceipt();
        },
        // 获取付款凭证-银行选择
        async GetBankname() {
            let res = await this.$newsApi.order.GetBankname();
            this.banknameList = res.data.data.map((item) => {
                return {
                    label: item,
                    value: item
                };
            });
            this.banknameList.unshift({
                label: '全部',
                value: ''
            });
        },
        // 获取凭证类型
        async GetReceiptType() {
            let res = await this.$newsApi.order.GetReceiptType();
            this.receiptTypeList = res.data.data.map((item) => {
                return {
                    label: item,
                    value: item
                };
            });
            this.receiptTypeList.unshift({
                label: '全部',
                value: ''
            });
        },
        // 重置数据
        resetData() {
            // 重置搜索条件
            this.jsonData = {
                bankname: '',
                receipttype: '',
                receiptcode: '',
                receiptcount: '',
                ReceiptPayDate: ''
            };
            // 重置分页
            this.paginationOptions = {
                Page: 1,
                total: 0,
                PageSize: 10
            };
            this.PaymentReceiptList = [];
            this.selectOrdersPaymentReceipt();
        },
        // 搜索
        getSPCOrders(flag = false) {
            if (flag) {
                // 重置分页到第一页
                this.paginationOptions.Page = 1;
            }
            this.selectOrdersPaymentReceipt();
        },
        // 选择凭证
        async selectOrdersPaymentReceipt() {
            // 分页参数应该作为独立参数传递，不放在JSON内部
            let json = JSON.stringify(this.jsonData);
            
            let result = await this.$newsApi.order.selectOrdersPaymentReceipt({
                json: json,
                Page: this.paginationOptions.Page,
                PageSize: this.paginationOptions.PageSize,
                cateid: this.cateid
            });
            
            if (result.data.Resultcode === 0) {
                this.PaymentReceiptList = result.data.data.map((item) => {
                    return {
                        ...item,
                        inputValue: '',
                        Receipt_ID_Show: 0
                    };
                });
                // 更新总数
                this.paginationOptions.total = result.data.total * this.paginationOptions.PageSize || 0;
                console.log('API返回数据:', result.data);
                console.log('总条数:', this.paginationOptions.total);
                console.log('当前页数据条数:', this.PaymentReceiptList.length);
            } else {
                this.PaymentReceiptList = [];
                this.paginationOptions.total = 0;
                console.log('API调用失败:', result.data);
            }
        },
        // 多选
        handleSelectionChange(val) {
            this.PaymentReceiptList = this.PaymentReceiptList.map((item) => {
                return {
                    ...item,
                    Receipt_ID_Show: item.Receipt_ID == val.Receipt_ID ? 1 : 0,
                    inputValue: item.Receipt_ID == val.Receipt_ID ? (item.Last_Amount <= this.residuePrice ? item.Last_Amount : this.residuePrice) : ''
                };
            });
        },
        selectable(row) {
            // 这里可以根据 row 的某些属性来决定是否可选
            return true; // 如果想控制某些行不可选可以进行判断
        },
        // 查看凭证附件
        viewPaymentReceiptFile(url) {
            window.open(url);
        },
        formatOnInput(row) {
            row.inputValue = this.formatMoneyOnInput(row.inputValue);
        },
        valueBlur(row) {
            row.inputValue = this.formatMoneyOnBlur(row.inputValue);
        },
        // 保存
        submit() {
            console.log(this.PaymentReceiptList);
            let list = this.PaymentReceiptList.filter((item) => item.Receipt_ID_Show == 1);
            if (list.length == 0) {
                this.$message.error('请选择凭证');
                return;
            }
            let needlist = list[0];
            this.$confirm('本次分款在满足条件时会自动审核通过，请确认付款凭证信息及本次分配金额是否准确！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (needlist.inputValue && Number(needlist.inputValue)) {
                        const keySuffix = this.cateid ? `_${this.cateid}` : '';
                        this.jsonShowData[`Receipt_ID${keySuffix}`] = needlist.Receipt_ID;
                        this.jsonShowData[`Receipt_Amount${keySuffix}`] = `${needlist.Receipt_ID}|${needlist.inputValue}`;

                        if (needlist.inputValue > Number(this.residuePrice)) {
                            this.$message.error('分款金额不可超过待付款余额');
                        } else {
                            if (needlist.inputValue > needlist.Last_Amount) {
                                this.$message.error('分款金额不可超过可用余额');
                            } else {
                                this.$emit('getPaymentReceipts', this.jsonShowData);
                            }
                        }
                    } else {
                        this.$message.error('请输入本次分配金额');
                        return;
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        openReceipt(type, row) {
            this.$refs.PaymentVoucherDialog.open(type, row || {});
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
